import authentication from '../middleware/authentication'
const Index = () => import(/* webpackChunkName: "static/js/chunks/absenceResponse" */'../../views/absenceResponse/index')

const absenceResponseRoutes = {
  path: '/absence-response',
  name: 'AbsenceResponse',
  component: Index,
  meta: {
    middleware: authentication,
    layout: 'main'
  }
}

export default absenceResponseRoutes
